module.exports = {
        srcSet: __webpack_public_path__ + "promotions_mmm-178-1a5580d485129c33.digested.png"+" 178w",
        images: [{path: __webpack_public_path__ + "promotions_mmm-178-1a5580d485129c33.digested.png",width: 178,height: 178}],
        src: __webpack_public_path__ + "promotions_mmm-178-1a5580d485129c33.digested.png",
        toString: function(){return __webpack_public_path__ + "promotions_mmm-178-1a5580d485129c33.digested.png"},
        
        width: 178,
        height: 178
      }